import { render, staticRenderFns } from "./ThumbnailMediaSetting.vue?vue&type=template&id=68baab57&"
import script from "./ThumbnailMediaSetting.vue?vue&type=script&lang=js&"
export * from "./ThumbnailMediaSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Ramon/PROYECTOS/JuanGabriel_POS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68baab57')) {
      api.createRecord('68baab57', component.options)
    } else {
      api.reload('68baab57', component.options)
    }
    module.hot.accept("./ThumbnailMediaSetting.vue?vue&type=template&id=68baab57&", function () {
      api.rerender('68baab57', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/settings/ThumbnailMediaSetting.vue"
export default component.exports